module.exports = function () {
    if ( document.querySelector(".popup-login") ) {
        $(".popup-btn").click(function (e) {

            e.preventDefault();
            var _target_popup = $(this).data('target-popup');

            if (_target_popup) {
                $('.popup-' + _target_popup).fadeIn()

                setTimeout(() => {
                    document.addEventListener("click", closeLoginPopup);
                }, 10);
            }
        });

        $(".close-popup").click(function () {
            document.removeEventListener("click", closeLoginPopup);

            var _this = $(this),
                _popup = $(".popup");

            _popup.fadeOut();
        });

        function closeLoginPopup(e) {
            if ( document.querySelector(".popup-login") && !document.querySelector(".popup-login").contains(e?.target) ) {
                document.removeEventListener("click", closeLoginPopup);

                var _this = $(this),
                    _popup = $(".popup");

                _popup.fadeOut();
            }
        }
    }
}